import AuthorizedCreditPermanent from '@/generated/controls/authorizedCredit/AuthorizedCreditPermanent.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: AuthorizedCreditPermanent
})
